import _ from 'lodash';

function flagSelector({ key }) {
  const flag = _.camelCase(key);

  return (state) => state.flags[flag];
}

function roleFlagSelector({ parent, key }) {
  const feature = [_.snakeCase(parent), _.snakeCase(key)].join('_');

  return (state) => {
    const group = _.find(state.user.groups, {
      group: { id: state.session.groupId },
    });
    if (!group) return false;

    return _.get(group.feature_flags, feature, false);
  };
}

function roleSelector({ role_key }) {
  return (state) => {
    const group = _.find(state.user.groups, {
      group: { id: state.session.groupId },
    });
    if (!group) return false;

    return Boolean(_.find(group.roles, (r) => r.role_key === role_key));
  };
}

export const cerb2115HighlightingDeactivatedPrograms = flagSelector({
  key: 'cerb-2115-highlighting-deactivated-programs-on-resource-lists',
});

export const cerb2050ResourcesUxEnhancements = flagSelector({
  key: 'cerb-2050-resources-ux-enhancements',
});

export const cerb1486Ny1115ClientSocialCareCoverageIds = flagSelector({
  key: 'cerb-1486-ny-1115-client-social-care-coverage-ids',
});

export const cerb1485Ny1115Networks = flagSelector({
  key: 'cerb-1485-ny-1115-networks',
});
export const cerb1519ScreeningRequiredFeeSchedules = flagSelector({
  key: 'cerb-1519-screening-required-fee-schedules',
});
export const cerb2028BoostServiceAreaValues = flagSelector({
  key: 'cerb-2028-boost-service-area-values',
});
export const pays6694RemoveContextPerson = flagSelector({
  key: 'pays-6694-remove-context-person',
});
export const pays5590RefactorInsuranceFilters = flagSelector({
  key: 'pays-5590-refactor-insurance-filters',
});
export const crtb2182ClarifyReferralLanguage = flagSelector({
  key: 'crtb-2182-clarify-referral-language',
});
export const hint1246HideLgbtqPlusFilter = flagSelector({
  key: 'hint-1246-hide-lgbtq-plus-filter',
});
export const scrn942ScreeningsResultsUpdates = flagSelector({
  key: 'SCRN-942-screenings-results-updates',
});

export const hint716SearchNetworkHubSupportPremiumSelector = flagSelector({
  key: 'hint-716-search-network-hub-support-premium',
});
export const useInvoiceDisputeWorkflow = flagSelector({
  key: 'useInvoiceDisputeWorkflow',
});
export const organizationPaginationLimit = flagSelector({
  key: 'organization-pagination-limit',
});
export const hasInAppNotifications = flagSelector({
  key: 'notifications-user',
});
export const hasInsightsUserRole = flagSelector({ key: 'insights-user-role' });
export const hasExportsUserRole = flagSelector({ key: 'exports-user-role' });
export const hasNetworkDirectoryUserRole = flagSelector({
  key: 'network-directory-user-role',
});
export const hasGeneralStaffUserRole = flagSelector({ key: 'staff-user-role' });
export const hasReportsUserRole = flagSelector({ key: 'reports-user-role' });
export const hasCoreConsolidation = flagSelector({ key: 'core-consolidation' });
export const hasNCCorrectPaymentWording = flagSelector({
  key: 'nc-correct-payment-wording',
});
export const usePhiDisclosure = flagSelector({
  key: 'uud-49-use-phi-disclosure',
});
export const hasCasesOONReferralUnlicensedOrgs = flagSelector({
  key: 'cases-oon-referral-unlicensed-orgs',
});
export const showProgramStatusToggle = flagSelector({
  key: 'show-program-status-toggle',
});
export const showPendo = flagSelector({ key: 'uucs-315-pendo-temp' });
export const hasNewSearchAndMatch = flagSelector({
  key: 'new-search-and-match',
});
export const useV4toGetOrganizations = flagSelector({
  key: 'uu3-47928-use-v4-open-cases-org-dropdown-temp',
});
export const hideResidencyRequirementsFilter = flagSelector({
  key: 'hide-residency-requirements-filter',
});
export const paginateNetworkGroups = flagSelector({
  key: 'paginate-network-groups',
});
export const expandAllReferralReviewSections = flagSelector({
  key: 'uu3-51060-expand-all-referral-review-sections-temp',
});
export const isMessagingEnabledFlag = flagSelector({
  key: 'uup-235-messaging-center-access',
});
export const isMessagingArchiveEnabledFlag = flagSelector({
  key: 'archive-messaging',
});
export const restrictToSubmissionContext = flagSelector({
  key: 'cpr-369-restrict-to-submission-context',
});
export const showTranslationsNewLanguages = flagSelector({
  key: 'translations-new-language',
});
export const serviceAreaSupportForOrgs = flagSelector({
  key: 'UUP-245-service-area-support-for-orgs',
});
export const hasInvoicesAccess = roleSelector({ role_key: 'invoices' });
export const hasReferralsUser = roleSelector({ role_key: 'referrals_user' });
export const hasPaysClaimsCodes = flagSelector({
  key: 'pays-claims-codes-dropdowns',
});

export const hasPayerInvoicesRole = roleSelector({
  role_key: 'payer_invoices',
});
export const hasPaymentsUserAccess = roleSelector({ role_key: 'payments' });

export const hasPayerAuthorizationAccess = roleSelector({
  role_key: 'service_authorizations',
});
export const hasCaseManagerRole = roleSelector({ role_key: 'case_manager' });
export const hasEnrollmentsWQ = flagSelector({ key: 'enrollment-wq' });
export const crtb1239AdaptDraftReferralFlow = flagSelector({
  key: 'crtb-1239-adapt-draft-referral-flow',
});
export const crtb1349VariableAWebApp = flagSelector({
  key: 'crtb-1349-variable-a-webb-app',
});
export const crtb1350VariableBWebApp = flagSelector({
  key: 'crtb-1350-variable-b-web-app',
});
export const crtb1351VariableCWebApp = flagSelector({
  key: 'crtb-1351-variable-c-web-app',
});

export const crtb1967DeactivatedProgramsInternalCasesFilter = flagSelector({
  key: 'crtb-1967-deactivated-programs-internal-cases-filter',
});

export const hasPayerEnrollmentsAccess = (state) => {
  const hasEnrollments = roleSelector({ role_key: 'enrollments' })(state);
  return hasEnrollments && hasEnrollmentsWQ(state);
};

export const crtb2130MultipleClientNeeds = flagSelector({
  key: 'crtb-2130-multiple-client-needs',
});

export const hasExports = (state) => roleFlagSelector({ parent: 'exports', key: 'exports_data' })(state);

export const hasInsightsViewInsights = (state) => roleFlagSelector({ parent: 'insights', key: 'view_insights' })(state);

const navRoleFlagSelector = ({ parent, key }) => {
  const hasRole = roleFlagSelector({ parent, key });
  return (state) => hasRole(state);
};

export const hasNetworkDirectoryAccess = navRoleFlagSelector({
  parent: 'network_directory',
  key: 'view_directory_emr',
});
export const hasContactsViewContacts = navRoleFlagSelector({
  parent: 'contacts',
  key: 'create_contacts',
});
export const hasContactsCreateContacts = navRoleFlagSelector({
  parent: 'contacts',
  key: 'create_contacts',
});
export const hasWorkflowViewIndex = navRoleFlagSelector({
  parent: 'workflow_index',
  key: 'view_index',
});
export const hasReportsViewReports = navRoleFlagSelector({
  parent: 'reports',
  key: 'view_reports',
});
export const hasTableauDashboard = flagSelector({
  key: 'uup-20-use-tableau-dashboard',
});
export const showNCDisplay = flagSelector({ key: 'nc-display-only' });

export const showFacesheetCasesTableDescription = flagSelector({
  key: 'facesheet-cases-table-description',
});

export const includePathwaysServices = flagSelector({
  key: 'service-types-include-pathways',
});

export const editResourceList = flagSelector({ key: 'edit-resource-lists' });

export const showNCTracks = flagSelector({ key: 'pays-1554-nctracks' });
export const showSCC = flagSelector({ key: 'PAYS_4502_show_scc' });
export const showAppClientProfile = flagSelector({ key: 'show-app-client-profile' });

export const pays7072DisallowSCCEditsByPlanScoping = flagSelector({
  key: 'pays-7072-disallow-editing-scc-based-on-social-plan-scope',
});

export const hasDeleteNoteIcon = flagSelector({
  key: 'tool-158-delete-note-icon',
});

export const isLearnEnabled = flagSelector({ key: 'unite-us-learn-link' });

export const isTasksListV2Enabled = flagSelector({ key: 'nc-task-list-v2' });

export const hideMoreFiltersOption = flagSelector({
  key: 'crtb-916-improve-dashboard-filters',
});

export const hint921ManualSendback = flagSelector({
  key: 'hint-921-manual-sendback',
});

export const hasLimitedGenderOptions = flagSelector({
  key: 'crtb-1120-hide-client-profile-gender-options',
});
export const crtb1121HideFieldInForm = flagSelector({
  key: 'crtb-1121-hide-field-in-form',
});
export const hbh1556RideHealthLinkMapping = flagSelector({
  key: 'hbh-1556-ride-health-link-mapping',
});
export const hasClientLinkOnClientFacesheet = flagSelector({
  key: 'crtb-1152-add-client-id-to-the-client-face-sheet',
});
export const hbh1025ShowEligibilityAssessmentTab = flagSelector({
  key: 'hbh-1025-show-eligibility-assessment-tab',
});

export const scrn7ScreeningsCompletion = flagSelector({ key: 'scrn7-screenings-completion' });
export const scrn468ScreeningTimeTracking = flagSelector({ key: 'scrn-468-screening-time-tracking' });
export const scrn655inboundScreeningsDashboard = flagSelector({ key: 'scrn-655-inbound-screenings-dashboard' });

export const pays3513PreventOverlappingRequests = flagSelector({
  key: 'pays-3513-prevent-overlapping-scc-and-enrollment-requests',
});

export const isClientMergingEnabled = flagSelector({ key: 'cl-67-client-merging' });
export const hasClientIdStandardization = flagSelector({ key: 'cl-657-id-standardization' });
export const cl787SexualityFields = flagSelector({ key: 'cl-787-sexuality-fields' });
export const cl1859ClientIntakeProfileFields = flagSelector({ key: 'cl-1859-client-intake-profile-fields' });
export const cl1987PeoplePronounsVisibility = flagSelector({ key: 'cl-1987-people-pronouns-visibility' });
export const cl1990AccommodationsSectionVisibility = flagSelector({ key: 'cl-1990-accommodations-section-visibility' });
export const assistanceRequestsExportsAvailable = flagSelector({
  key: 'hbh-1022-in-app-exports',
});
export const resourceSharesExportsAvailable = flagSelector({
  key: 'hbh-1559-export-resource-shares',
});
export const screeningsv2ExportsAvailable = flagSelector({
  key: 'hbh-1991-export-screenings2',
});
export const cl1292clientsIndexMaterializedView = flagSelector({
  key: 'cl-1292-clients-index-materialized-view',
});
export const cl2234searchIncludesNetworkResults = flagSelector({
  key: 'cl-2234-search-includes-network-results',
});
export const cl2267AddNoMilitaryAffiliation = flagSelector({
  key: 'cl-2267-add-no-military-affiliation',
});

export const cl1224UnconsentedClientFacesheetAccess = flagSelector({
  key: 'cl-1224-unconsented-client-face-sheet-access',
});

export const pays7267IncludeInternalNonConsentedClients = flagSelector({
  key: 'PAYS-7267-include-internal-nonconsent',
});

export const hbh1430AudioEyeEnabled = flagSelector({
  key: 'hbh-1430-audio-eye-enabled',
});

export const pays7390CopyrightText = flagSelector({
  key: 'pays-7390-copyright-text',
});

export const hbh1710ClientsDrawerLatestActivity = flagSelector({
  key: 'hbh-1710-clients-drawer-latest-activity',
});

export const cl1540simplePaging = flagSelector({
  key: 'cl-1540-simple-paging',
});

export const pays9123VerifyInsurance = flagSelector({
  key: 'pays-9123-verify-insurance',
});

export const hbh1713ClientsDrawerDocuments = flagSelector({
  key: 'hbh-1713-clients-drawer-documents',
});

export const hbh1667pfrUnifiedTaskEngine = flagSelector({
  key: 'hbh-1667-pfr-unified-task-engine',
});

export const pays9369ShowExcludedPopulationMessage = flagSelector({
  key: 'pays-9369-show-excluded-population-message',
});

export const hint2602ShowProviderOnboarding = flagSelector({
  key: 'hint-2602-show-provider-onboarding',
});

export const pays9502ShowCreatedViaRteMessage = flagSelector({
  key: 'pays-9502-show-created-via-rte-message',
});

export const pays8125AllowExpiredInsuranceNotification = flagSelector({
  key: 'pays-8125-allow-expired-insurance-notification',
});

export const pays5650UpdateEditAuthorizations = flagSelector({
  key: 'pays-5650-update-edit-authorizations',
});

export const pays8036AllowInsuranceMemberIdFilter = flagSelector({
  key: 'pays-8036-allow-insurance-member-id-filter',
});

export const crtb2052SaveClosedDate = flagSelector({
  key: 'crtb-2052-save-closed-date',
});

export const cl2296MedicaidId = flagSelector({
  key: 'cl-2296-medicaid-id',
});
